import { render } from "./CityTerminal.vue?vue&type=template&id=76e4c15a&ts=true"
import script from "@/composables/pages/master-setting/city-terminal/CityTerminalComposable?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/city-terminal/CityTerminalComposable?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__